document.addEventListener("DOMContentLoaded", function() {
  const swiper = new Swiper('.swiper', {
     loop: false,
     freeMode: false,
     slidesPerView: 1,
     spaceBetween: 20,
           autoplay: {
        delay: 2000,
        disableOnInteraction: false,
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: 4,
        },
      },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  });
  var swiperMultiInit = false;
var swiperMulti;
function swiperCard() {
  if (window.innerWidth >= 768) {
    if (!swiperMultiInit) {
      swiperMultiInit = true;
     swiperMulti = new Swiper('.swiper-container-multicolumn', {
     loop: false,
     freeMode: false,
     slidesPerView: 1,
     // spaceBetween: 20,
      breakpoints: {
        640: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 2.5,
        },
        1200: {
          slidesPerView: 2.5,
        },
        1400: {
          slidesPerView: 3.2,
        },
      },
    navigation: {
      nextEl: '.swiper-button-next-multi',
      prevEl: '.swiper-button-prev-multi',
    }
  })
      }
  } else {
    if (swiperMultiInit){
    swiperMulti.destroy();
    swiperMultiInit = false;
    }

  }
}
swiperCard();
 window.addEventListener("resize", swiperCard);


  const multiColumnswiper = new Swiper('.swiper-multicolumn-container', {
     loop: false,
     freeMode: false,
     slidesPerView: 2,
     spaceBetween: 0,
     pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          grid: {
            rows: 2,
            fill: 'row',
          },
          slidesPerGroup: 4,
        },
        768: {
          slidesPerView: 2.5,
          slidesPerGroup: 1,
        },
        1200: {
          spaceBetween: 20,
          slidesPerView: 3.6,
          slidesPerGroup: 1,
          grid: {
            rows: 1
          },
        },
      },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  });

// var multiColumnswiperInit = false;
// var multiColumnswiper;

// function multiColumnswiperCard() {
//   if (window.innerWidth >= 768) {
//     if (!multiColumnswiperInit) {
//       multiColumnswiperInit = true;
//       multiColumnswiper = new Swiper('.swiper-multicolumn-container', {
//         loop: false,
//         freeMode: false,
//         slidesPerView: 1.5,
//         spaceBetween: 20,
//         breakpoints: {
//           768: {
//             slidesPerView: 3.1,
//           },
//           1024: {
//             slidesPerView: 3.6,
//           },
//         },
//         navigation: {
//           nextEl: '.swiper-button-next',
//           prevEl: '.swiper-button-prev',
//         }
//       });
//     }
//   } else {
//     if (multiColumnswiperInit && multiColumnswiper) {
//       multiColumnswiper.destroy(true, true); 
//       multiColumnswiper = null;
//       multiColumnswiperInit = false;
//     }
//   }
// }

// let resizeTimeout;
// function handleResize() {
//   clearTimeout(resizeTimeout);
//   resizeTimeout = setTimeout(multiColumnswiperCard, 250);
// }

// multiColumnswiperCard();  // Initial call
// window.addEventListener("resize", handleResize);

  document.querySelectorAll('.enroll').forEach(element => {
    element.addEventListener('click', function(event) {
    if (element.hasAttribute('href') && element.getAttribute('href').trim() === '') {
            event.preventDefault(); // Prevent default action if href is blank
          if (!document.querySelector('#messageDiv')) {
            // Create the message div
            const messageDiv = document.createElement('div');
            messageDiv.id = 'messageDiv';
            messageDiv.textContent = 'Please select an option.';
            messageDiv.style.color = 'red';
            messageDiv.style.marginTop = '10px';
let selectElement = document.querySelector('#selectRedirect2').parentElement;
            selectElement.parentNode.insertBefore(messageDiv, selectElement);
        }
        }
    });
  });
  document.addEventListener('click', function(e) {
    var target = e.target;

    if (target.tagName === 'SPAN' && target.parentElement.tagName === 'A') {
        target = target.parentElement;
    }

    if (target.tagName === 'A' && target.getAttribute('href').startsWith('#')) {
        e.preventDefault();
        var id = target.getAttribute('href').substring(1);
        if(id == 'careerpopup'){
         var modal = document.getElementById("careerModal");
         var span = document.getElementsByClassName("career-modal-close")[0];
          modal.style.display = "block";
          span.onclick = function() {
            modal.style.display = "none";
          }
        }else{
          var element = document.getElementById(id);
          if (element) {
           var elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
           var offsetPosition = elementPosition - 200;
            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
          }
            }
    }
});
  if(document.querySelector('#selectRedirect')){
    document.querySelector('#selectRedirect').addEventListener('change', function(e) {
      e.preventDefault();
      let selectValue = document.querySelector('#selectRedirect').value;
      if(selectValue !== ''){
        window.location.href = selectValue;
      }
    });
  }
  if(document.querySelector('#selectRedirect2')){
    document.querySelector('#selectRedirect2').addEventListener('change', function(e) {
      e.preventDefault();
      let selectValue = document.querySelector('#selectRedirect2').value;
   if(selectValue !== ''){
       let nextElement = document.querySelector('#selectRedirect2').nextElementSibling;
        nextElement.setAttribute('href', selectValue);
         nextElement.removeAttribute('aria-disabled');
        nextElement.removeAttribute('role');
      const existingMessageDiv = document.querySelector('#messageDiv');
        if (existingMessageDiv) {
            existingMessageDiv.remove();
        }
    //    window.location.href = selectValue;
      }else{
     if (!document.querySelector('#messageDiv')) {
            // Create the message div
            const messageDiv = document.createElement('div');
            messageDiv.id = 'messageDiv';
            messageDiv.textContent = 'Please select an option.';
            messageDiv.style.color = 'red';
            messageDiv.style.marginTop = '0px';

            let selectElement = document.querySelector('#selectRedirect2').parentElement;
            selectElement.parentNode.insertBefore(messageDiv, selectElement);
        }
         let nextElement = document.querySelector('#selectRedirect2').nextElementSibling;
       // nextElement.setAttribute('aria-disabled', 'true');
        nextElement.setAttribute('role', 'link');
         nextElement.setAttribute('href', '');
      }
    });
   }
  let placement_video_buttons = document.querySelectorAll('.placement_button');
  placement_video_buttons.forEach( (button) => {
    button.addEventListener('click', (event) => {
       let videoUrl = event.target.dataset.videoUrl;
      if(!event.target.classList.contains('placement_button')){
        videoUrl = event.target.parentElement.dataset.videoUrl;
      }
   
    var modal = document.getElementById("placementModal");
    modal.querySelector('.placement-video').innerHTML = `<iframe src="${videoUrl}" class="js-youtube" allow="autoplay; encrypted-media" allowfullscreen ></iframe>`;
         var span = document.getElementsByClassName("placement-modal-close")[0];
          modal.style.display = "block";
          span.onclick = function() {
            modal.querySelector('.placement-video').innerHTML = '';
            modal.style.display = "none";
          }
      })
  });
    let placementSlide_video_buttons = document.querySelectorAll('.slide-play-button');
  placementSlide_video_buttons.forEach( (button) => {
    button.addEventListener('click', (event) => {
       let videoUrl = event.target.dataset.videoUrl;
      if(!event.target.classList.contains('slide-play-button')){
        videoUrl = event.target.parentElement.dataset.videoUrl;
      }
   
    var modal = document.getElementById("placementModal");
    modal.querySelector('.placement-video').innerHTML = `<iframe src="${videoUrl}" class="js-youtube" allow="autoplay; encrypted-media" allowfullscreen ></iframe>`;
         var span = document.getElementsByClassName("placement-modal-close")[0];
          modal.style.display = "block";
          span.onclick = function() {
            modal.querySelector('.placement-video').innerHTML = '';
            modal.style.display = "none";
          }
      })
  });
  let loadMoreButtons = document.querySelectorAll('.load-more');
  loadMoreButtons.forEach( (button) => {
    button.addEventListener('click', (event) => {
      button.style.display = "none";
      console.log(event);
      event.target.parentElement.parentElement.nextElementSibling.classList.remove('load-later');
      // let indexNew = button.dataset.next;
      // document.querySelectorAll('.placed-candidates-container').forEach( (containerPlace) => {
      //   if(containerPlace.dataset.index <= indexNew){
      //     button.style.display = "none";
      //     containerPlace.classList.remove('load-later');
      //   }

      // })
    })
  });
  window.onload = function(){
  setTimeout(function() {
    if(document.querySelector('#hpModal')){
   document.querySelector('#hpModal').style.display = "block";
    document.getElementsByClassName("hp-modal-close")[0].onclick = function() {
      document.querySelector('#hpModal').style.display = "none";
    }
    }
  }, 5000);
  }
  function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

// Example usage
if(document.querySelector('.course-desktop')){
  const element = document.querySelector('.course-desktop').querySelector('.button-register'); // Replace with your element selector
  if (element) {
      window.addEventListener('scroll', () => {
          if (isInViewport(element)) {
            if(document.querySelector('.desktop_only_fixed_pdp_container')){
             document.querySelector('.desktop_only_fixed_pdp_container').classList.remove('fixed');
            }
          } else {
            if(document.querySelector('.desktop_only_fixed_pdp_container')){
            document.querySelector('.desktop_only_fixed_pdp_container').classList.add('fixed');
            }
          }
      });
  }
}
  if(document.querySelector('.course-mobile')){
    const elementMobile = document.querySelector('.course-mobile').querySelector('.button-register'); // Replace with your element selector
if (elementMobile) {
    window.addEventListener('scroll', () => {
        if (isInViewport(elementMobile)) {
          if(document.querySelector('.mobile_only_fixed_pdp_container')){
           document.querySelector('.mobile_only_fixed_pdp_container').classList.remove('fixed');
          }
        } else {
          if(document.querySelector('.mobile_only_fixed_pdp_container')){
          document.querySelector('.mobile_only_fixed_pdp_container').classList.add('fixed');
          }
        }
    });
}
  }
  if(document.querySelector('.course-mobile')){
    const courseMobile = document.querySelector('.course-mobile');
    const anchor = document.createElement('a');
    anchor.setAttribute('class', 'course-mobile-anchor');
    anchor.href = courseMobile.querySelector('.button-register').getAttribute('href');
    courseMobile.parentNode.insertBefore(anchor, courseMobile);
    anchor.appendChild(courseMobile);
  }

  if(document.querySelector('.course-tab')){
    let courseTabs = document.querySelectorAll('.course-tab');
    courseTabs.forEach( (courseTab) => {
      courseTab.addEventListener('click', (event) => {
        let clickedTab = event.target;
        document.querySelector('.course-tab.active').classList.remove('active');
        document.querySelector('.course-content.active').classList.remove('active');
        clickedTab.classList.add('active');
        let currentTabId = clickedTab.getAttribute('data-id');
        document.querySelector('#'+currentTabId).classList.add('active');
      })
    })
  }
});